module.exports = __webpack_public_path__ + "media/images/tl/banner/zh-hans-2-light-aff97a2dfd60404677a91c52537f623d.jpg";